import { render, staticRenderFns } from "./EmbeddedMeetingSidebar.vue?vue&type=template&id=657092e5&scoped=true"
import script from "./EmbeddedMeetingSidebar.vue?vue&type=script&lang=js"
export * from "./EmbeddedMeetingSidebar.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedMeetingSidebar.vue?vue&type=style&index=0&id=657092e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657092e5",
  null
  
)

export default component.exports